module.exports = __webpack_public_path__ + "static/media/19.3384eddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/19.png
// module id = 1059
// module chunks = 0